import { IMessageType } from '@/services/signalr/types';
import { IStatusMsg } from '~/api/messages/IStatusMsg';
import { ITransportRequestUpdateReqMsg } from '~/api/messages/ITransportRequestUpdateReqMsg';

export const TransportRequestUpdateReqMsg: IMessageType<ITransportRequestUpdateReqMsg, IStatusMsg> = {
  requestName: 'TransportRequestUpdateReqMsg',
  responseName: 'StatusMsg',
};
